var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"f-list-page-page veui-pagination"},[_c('div',{staticClass:"veui-pagination-switch"},[_c('div',{class:{
                'veui-pagination-prev': true,
                'veui-disabled': _vm.page === 1 || _vm.pageCount === 0,
                'veui-link': true
            },attrs:{"aria-label":"上一页"},on:{"click":function($event){return _vm.handlePageClick(_vm.pageNavHref.prev)}}},[_c('veui-icon',{attrs:{"name":"chevron-left"}})],1),_c('ul',{staticClass:"veui-pagination-pages"},_vm._l((_vm.pageIndicatorSeries),function(item){return _c('li',{key:_vm.getKey(item),class:{
                    'veui-pagination-page': true,
                    'veui-active': item.current
                }},[_c('div',{class:{
                        'veui-current': item.current,
                        'veui-disabled': item.current,
                        'veui-pagination-more': item.more,
                        'veui-link': true
                    },on:{"click":function($event){return _vm.handlePageClick(item)}}},[(item.more)?[_c('veui-icon',{staticClass:"veui-pagination-more-ellipsis",attrs:{"name":"ellipsis-h"}})]:[_vm._v(_vm._s(item.text))]],2)])}),0),_c('div',{class:{
                'veui-pagination-next': true,
                'veui-disabled': _vm.page === _vm.pageCount || _vm.pageCount === 0,
                'veui-link': true
            },on:{"click":function($event){return _vm.handlePageClick(_vm.pageNavHref.next)}}},[_c('veui-icon',{attrs:{"name":"chevron-right"}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }